// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wmZM","controls":"styles_controls__1TG1L","charLimit":"styles_charLimit__BzTn6","input":"styles_input__p1vnI","send":"styles_send__DQoBs"};